/**
 * @generated SignedSource<<90bceda30edf800fb1ee751d150999ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ErrorType = "ERR_ADSLOT" | "ERR_CARD_BIRTH" | "ERR_CARD_EXPIRED" | "ERR_CARD_NUMBER" | "ERR_CARD_PASSWORD" | "ERR_CARD_PASSWORD_FIVE_TIMES" | "ERR_CREATE_SURVEY_ANSWER" | "ERR_DUPLICATE_APPLY" | "ERR_ETC" | "ERR_EXIST_FINISH_REFUND" | "ERR_EXIST_SEARCH_HISTORY" | "ERR_EXPIRE_URL" | "ERR_HECTO_ETC" | "ERR_HOMETAX_BLOCK_ID" | "ERR_HOMETAX_CALCULATE" | "ERR_HOMETAX_COLLECT" | "ERR_HOMETAX_ETC" | "ERR_HOMETAX_EXPIRE_CERT" | "ERR_HOMETAX_IMPOSSIBLE" | "ERR_HOMETAX_INPUT" | "ERR_HOMETAX_NO_BMAN" | "ERR_HOMETAX_NO_CONTINUE_BMAN" | "ERR_HOMETAX_NO_CORPS_ID" | "ERR_HOMETAX_NO_INCOME_TAX" | "ERR_HOMETAX_NO_JUMIN_ID" | "ERR_HOMETAX_NO_REGIST_CERT" | "ERR_HOMETAX_NO_USER" | "ERR_HOMETAX_OVERLOAD" | "ERR_HOMETAX_PASSWORD" | "ERR_HOMETAX_PASSWORD_CHANGE_REQUEST" | "ERR_HOMETAX_REG_NO" | "ERR_HOMETAX_SERVER_FIX" | "ERR_HOMETAX_SESSION" | "ERR_HOMETAX_SIMPLE_AUTH" | "ERR_HOMETAX_TIMEOUT" | "ERR_LEAVE_REASON" | "ERR_LEAVE_REASON_LOG" | "ERR_NON_PRODUCT_PROMOTION" | "ERR_NOT_EXIST_HISTORY" | "ERR_NOT_EXIST_YEAR_END_TAX_SETTLEMENT" | "ERR_NO_EQUAL_TIN" | "ERR_PROMOTION" | "ERR_SSO" | "ERR_SURVEY" | "ERR_SURVEY_ANSWER" | "ERR_SURVEY_COMPLETED" | "ERR_SURVEY_EXPIRED" | "ERR_UPDATE_SURVEY_ANSWER" | "ERR_USER" | "ERR_USER_ACTION_LOG" | "ERR_USER_PHONE";
export type YesNoEtc = "etc" | "no" | "yes";
export type businessIsStartBusinessDirectlyMutation$variables = {
  bmanTin: string;
  isCompleted: boolean;
  isStartBusinessDirectly?: YesNoEtc | null | undefined;
  surveyAnswerId: string;
};
export type businessIsStartBusinessDirectlyMutation$data = {
  readonly upsertBusinessAnswer: {
    readonly errors: {
      readonly code: ErrorType;
      readonly message: string | null | undefined;
    } | null | undefined;
    readonly result: boolean;
  };
};
export type businessIsStartBusinessDirectlyMutation = {
  response: businessIsStartBusinessDirectlyMutation$data;
  variables: businessIsStartBusinessDirectlyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bmanTin"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isCompleted"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isStartBusinessDirectly"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "surveyAnswerId"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "bmanTin",
        "variableName": "bmanTin"
      },
      {
        "kind": "Variable",
        "name": "isCompleted",
        "variableName": "isCompleted"
      },
      {
        "kind": "Variable",
        "name": "isStartBusinessDirectly",
        "variableName": "isStartBusinessDirectly"
      },
      {
        "kind": "Variable",
        "name": "surveyAnswerId",
        "variableName": "surveyAnswerId"
      }
    ],
    "concreteType": "RefundUserPutSurveyAnswerOutput",
    "kind": "LinkedField",
    "name": "upsertBusinessAnswer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Errors",
        "kind": "LinkedField",
        "name": "errors",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "businessIsStartBusinessDirectlyMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "businessIsStartBusinessDirectlyMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "f22e920cf8134449bb4d45fa342831cf",
    "id": null,
    "metadata": {},
    "name": "businessIsStartBusinessDirectlyMutation",
    "operationKind": "mutation",
    "text": "mutation businessIsStartBusinessDirectlyMutation(\n  $surveyAnswerId: String!\n  $bmanTin: String!\n  $isCompleted: Boolean!\n  $isStartBusinessDirectly: YesNoEtc\n) {\n  upsertBusinessAnswer(surveyAnswerId: $surveyAnswerId, bmanTin: $bmanTin, isCompleted: $isCompleted, isStartBusinessDirectly: $isStartBusinessDirectly) {\n    result\n    errors {\n      code\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0de4b0686cff524cf542fb2d954a20dc";

export default node;
